import { render, staticRenderFns } from "./PMessageWidget.vue?vue&type=template&id=27076dc3"
import script from "./PMessageWidget.vue?vue&type=script&lang=js"
export * from "./PMessageWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports